<template>
  <div
    id="panel"
    class="panel"
  >
    <div class="panel-title">
      <p>评价管理</p>
    </div>
    <div class="panel-content">
      <form
        id="searchSection"
        onSubmit="return false;"
      >
        <div class="search-line clearfix">
          <input
            type="text"
            v-model="queryInfo.user_name"
            class="s-input separate"
            placeholder="姓名"
          >
          <input
            type="text"
            v-model="queryInfo.experiment_title"
            class="s-input separate"
            placeholder="实验名称"
          >
          <input
            type="date"
            id="date"
            v-model="queryInfo.created"
            class="s-input separate"
            placeholder="日期"
          >
          <input
            type="submit"
            class="s-btn"
            value="搜索"
            @click="queryInfo.page=1,search()"
          >
        </div>
      </form>
      <div
        id="list"
        class="list"
      >
        <table v-if="tableData.length">
          <!-- 学院管理 -->
          <tr class="l_header">
            <th>姓名</th>
            <th>实验名称</th>
            <th>发表日期</th>
            <th>评分</th>
            <th>评语</th>
            <th
              class="action"
              width="180"
            >操作</th>
          </tr>
          <tr
            class="item"
            v-for="(item,index) in tableData"
            :key="index"
          >
            <td>{{item.userprofile.name}}</td>
            <td>{{item.experiment.title}}</td>
            <td>{{item.created.substr(0,10)}}</td>
            <td>{{item.grade}}</td>
            <td>{{item.content}}</td>
            <td class="action">
              <a
                class="delete"
                href="javascript:;"
                @click="askDel(item.id)"
              >删除</a>
            </td>
          </tr>
        </table>
        <div
          class="noitems"
          v-else
        >没有数据</div>
      </div>
      <!-- 分页 -->
      <pagination
        :cur='pageInfo.page'
        :all='pageInfo.all'
        :totalData="pageInfo.totalData"
        :callback="pageCallback"
      ></pagination>
    </div>
  </div>
</template>

<script>
import Pagination from '../../../components/Pager'
export default {
  name: 'Appraise',
  components: {
    Pagination
  },
  data() {
    return {
      classShowEditWindow: {},
      queryInfo: {
        page: 1,
        size: 10,
        experiment_title: '',
        user_name: '',
        created: ''
      },
      tableData: [],
      tableDataCount: 0

    }
  },
  // 计算属性
  computed: {
    pageInfo() {
      return {
        page: this.queryInfo.page,
        all: Math.ceil(this.tableDataCount / this.queryInfo.size),
        totalData: this.tableDataCount
      }
    }
  },
  methods: {
    // 分页
    pageCallback(data) {
      this.queryInfo.page = data
      this.search()
    },
    async search() {
      await this.$http.get('/experimentappraise/', {
        params: this.queryInfo
      }).then((data) => {
        this.tableData = data.results
        this.tableDataCount = data.count
      }).catch((error) => {
        console.log(error)
      })
    },
    async askDel(id) {
      const url = '/experimentappraise/' + id + '/'
      await this.$parent.showConfirm('确认删除此评论吗?', () => {
        this.$http.put(url, {
          isdel: 1
        }).then((data) => {
          this.$parent.showMsg('删除成功！')
          this.search()
        }).catch((error) => {
          console.log(error)
          this.$parent.showMsg('删除失败！')
        })
      })
    }
  },
  mounted() {
    this.search()
  }
}
</script>

<style scoped>
</style>
